@let checkoutMinorUnit = cartTotals().currency_minor_unit || 2;

<app-sidebar-wrapper [(isOpen)]="isOpen" [position]="SidebarPosition.Right">
  <div class="header">
    <h3 class="header__title">Your Cart</h3>
  </div>

  <div class="content">
    <div class="content__checkout">
      <app-button
        routerLink="/checkout"
        class="content__checkout-button checkout-button"
        [size]="ButtonSize.Large"
        (buttonClick)="closeSidebar()"
      >
        <span class="checkout-button__name">Checkout</span>
        <span class="checkout-button__value">
            {{
            cartTotals().total_items || '0.00'
              | formattedCurrency: checkoutMinorUnit
          }}
          </span>
      </app-button>
    </div>

    <ul class="content__restaurants restaurants">
      <li class="restaurants__item restaurant">
        <h4 class="restaurant__title" [innerHTML]="restaurant().name"></h4>

        @if (isCartLoading()) {
          <app-loader />
        } @else {
          <ul class="restaurant__products products">
            @for (cartItem of cartItems(); track $index) {
              @let price =
                +(cartItem.prices.price || cartItem.prices.regular_price);
              @let isUpdateDisabled =
                isDeleteLoading() ||
                isUpdateLoading() ||
                isSyncLoading() ||
                isAddItemLoading() ||
                !cartItem?.quantity_limits?.editable;

              <app-cart-sidebar-item
                class="products__item"
                [name]="cartItem.name"
                [image]="(cartItem | productImage) || ''"
                [price]="price.toString()"
                [addOns]="cartItem.item_data"
                [quantity]="cartItem.quantity"
                [minQuantity]="cartItem?.quantity_limits?.minimum || 1"
                [maxQuantity]="cartItem?.quantity_limits?.maximum || 100"
                [cartMinorUnit]="checkoutMinorUnit"
                [isDisabled]="isUpdateDisabled"
                (update)="updateProductQuantity(cartItem.key, $event)"
                (remove)="removeProduct(cartItem.key)"
              />
            } @empty {
              <li class="products__empty">
                <h5 class="products__empty_label">Cart is Empty</h5>
              </li>
            }
          </ul>
        }
      </li>
    </ul>

    @if (filteredPopularProducts().length > 0) {
      <div class="content__others others">
        <h3 class="others__title">Other Popular Items</h3>

        <div class="others__products">
          <ul class="others__products_list">
            @for (popularProduct of filteredPopularProducts(); track $index) {
              <li class="others__products_list-item popular-item">
                <div class="popular-item__general">
                  @if ((popularProduct | productImage)) {
                    <img
                      class="popular-item__general-image"
                      alt="popular product"
                      loading="lazy"
                      [src]="(popularProduct | productImage)"
                    />
                  }

                  <div class="popular-item__info">
                    <h5 class="popular-item__info-name">
                      {{ popularProduct.name }}
                    </h5>
                    <span class="popular-item__info-price">
                      {{
                        popularProduct.prices.price
                          | formattedCurrency: checkoutMinorUnit
                      }}
                    </span>
                  </div>
                </div>

                <div class="popular-item__add">
                  <app-button
                    [size]="ButtonSize.Icon"
                    (click)="openMealSelectionModal(popularProduct)"
                  >
                    <i class="icon icon-plus"></i>
                  </app-button>
                </div>
              </li>
            }
          </ul>
        </div>
      </div>
    }
  </div>

  <div class="footer">
    <div class="footer__buttons">
      <app-button
        routerLink="/"
        class="footer__buttons-add-more"
        [outline]="true"
        [style]="ButtonStyle.Contrast"
        (buttonClick)="closeSidebar()"
      >
        + Add More Items
      </app-button>
      <app-button
        routerLink="/checkout"
        class="footer__buttons-checkout"
        [style]="ButtonStyle.Contrast"
        (buttonClick)="closeSidebar()"
      >
        Checkout
      </app-button>
    </div>
  </div>
</app-sidebar-wrapper>
